import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="container-fluid mt-5 footer-container">
      <div className="row">
        <div className="col-lg-8 col-md-8 col-sm-9 mx-auto text-center py-5">
          <h2>
            Join the Adventure newsletter to receive our best vacation deals
          </h2>
          <h4 className="py-3">You can unsubscribe at any time.</h4>
          <form className="mb-3">
            <input type="email" />
            <button>Subscribe</button>
          </form>
          <div className="row align-items-center my-5 mx-5">
            <div className="col-lg-3 col-md-6 col-sm text-start">
                <h4 className="mb-2">About Us</h4>
                <ul>
                    <li>How is works</li>
                    <li>Testimonials</li>
                    <li>Careers</li>
                    <li>Investors</li>
                    
                </ul>
            </div>
            <div className="col-lg-3 col-md-6 col-sm text-start">
                <h4 className="mb-2">Contact Us</h4>
                <ul>
                    <li>Contact</li>
                    <li>Support</li>
                    <li>Destinations</li>
                    <li>Sponsorships</li>
                    
                </ul>
            </div>
            <div className="col-lg-3 col-md-6 col-sm text-start">
                <h4 className="mb-2">Videos</h4>
                <ul>
                    <li>Submit Video</li>
                    <li>Ambassadors</li>
                    <li>Agency</li>
                    <li>Influencers</li>
                    
                </ul>
            </div>
            <div className="col-lg-3 col-md-6 col-sm text-start">
                <h4 className="mb-2">Social Media</h4>
                <ul>
                    <li>Instagram</li>
                    <li>Youtube</li>
                    <li>Twitter</li>
                    <li>Facebook</li>
                    
                </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
